import {
  HEADER_ONBOARDING_CONGRATULATIONS_VIEW,
} from './types';

export const triggerOnboardingCongratulationsIsViewed = (pageName) => ({
  type: HEADER_ONBOARDING_CONGRATULATIONS_VIEW,
  pageName,
});
